/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccAdmissionRecord
 */
export interface PccAdmissionRecord {
    /**
     * 
     * @type {string}
     * @memberof PccAdmissionRecord
     */
    exacare_admission_status?: string;
    /**
     *
     * @type {string}
     * @memberof PccAdmissionRecord
     */
    exacare_bed_id?: string;
    /**
     *
     * @type {string}
     * @memberof PccAdmissionRecord
     */
    entered_by?: string;
    /**
     * 
     * @type {string}
     * @memberof PccAdmissionRecord
     */
    floor?: string;
    /**
     * 
     * @type {string}
     * @memberof PccAdmissionRecord
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof PccAdmissionRecord
     */
    room?: string;
    /**
     * 
     * @type {string}
     * @memberof PccAdmissionRecord
     */
    bed?: string;
    /**
     * 
     * @type {string}
     * @memberof PccAdmissionRecord
     */
    payer_code?: string;
    /**
     * 
     * @type {string}
     * @memberof PccAdmissionRecord
     */
    payer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PccAdmissionRecord
     */
    payer_type?: string;
}

/**
 * Check if a given object implements the PccAdmissionRecord interface.
 */
export function instanceOfPccAdmissionRecord(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PccAdmissionRecordFromJSON(json: any): PccAdmissionRecord {
    return PccAdmissionRecordFromJSONTyped(json, false);
}

export function PccAdmissionRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccAdmissionRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exacare_admission_status': !exists(json, 'exacare_admission_status') ? undefined : json['exacare_admission_status'],
        'exacare_bed_id': !exists(json, 'exacare_bed_id') ? undefined : json['exacare_bed_id'],
        'entered_by': !exists(json, 'entered_by') ? undefined : json['entered_by'],
        'floor': !exists(json, 'floor') ? undefined : json['floor'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
        'room': !exists(json, 'room') ? undefined : json['room'],
        'bed': !exists(json, 'bed') ? undefined : json['bed'],
        'payer_code': !exists(json, 'payer_code') ? undefined : json['payer_code'],
        'payer_name': !exists(json, 'payer_name') ? undefined : json['payer_name'],
        'payer_type': !exists(json, 'payer_type') ? undefined : json['payer_type'],
    };
}

export function PccAdmissionRecordToJSON(value?: PccAdmissionRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exacare_admission_status': value.exacare_admission_status,
        'exacare_bed_id': value.exacare_bed_id,
        'entered_by': value.entered_by,
        'floor': value.floor,
        'unit': value.unit,
        'room': value.room,
        'bed': value.bed,
        'payer_code': value.payer_code,
        'payer_name': value.payer_name,
        'payer_type': value.payer_type,
    };
}

